import { render, staticRenderFns } from "./calendarthree.vue?vue&type=template&id=25c48906&scoped=true&"
import script from "./calendarthree.vue?vue&type=script&lang=js&"
export * from "./calendarthree.vue?vue&type=script&lang=js&"
import style0 from "./calendarthree.vue?vue&type=style&index=0&id=25c48906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c48906",
  null
  
)

export default component.exports